module.exports = __webpack_public_path__ + "media/images/ninestars/clients/client-5-706cfcc79fadfb19e097936341c2a144.png";